import React from 'react';
import BrandPolicyPage from '../PolicyPage/BrandPolicyPage';

const TermsOfServicePolicyPage: React.FC = () => <BrandPolicyPage doc="terms" />;

export default TermsOfServicePolicyPage;
